import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CodeSnippetService } from '@services/code-snippets/code-snippet.service';
import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Component({
  selector: 'edit-app-dialog',
  templateUrl: './code-snippet-edit-dialog.component.html',
  styleUrls: ['./code-snippet-edit-dialog.component.scss'],
  providers: [CodeSnippetService],
  standalone: false
})
export class CodeSnippetEditDialogComponent implements OnInit {
  snippet: Models.CodeSnippet;

  constructor(
    public dialogRef: MatDialogRef<CodeSnippetEditDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private snippetService: CodeSnippetService,
    private snackbar: SnackbarService
  ) {
  }

  async ngOnInit() {
    this.snippet = (await this.snippetService.find(0, 1, { name: this.data }))?.data?.[0];
  }

  async save() {
    if (this.snippet.type !== 'scss') {
      this.snippet.compiledCode = this.snippet.code;
    }
    if (this.snippet.type === 'json' && !this.testJson()) {
      return false;
    }
    const validation = await this.snippet.validate(true);
    if (validation.success) {
      try {
        await this.snippetService.update(this.snippet._id, this.snippet);
        this.dialogRef.close();
        this.snackbar.success('Code Snippet gespeichert!', 50000);
      } catch (e) {
        this.snackbar.error('Invalid Syntax: ' + e?.error?.message || e?.message, 50000);
      }
    } else {
      console.log(validation);
      this.snackbar.open('Could not create the Snippet, please fill in the form correctly');
    }
  }

  testJson() {
    try {
      JSON.parse(this.snippet.code);
    } catch (e) {
      this.snackbar.error('Invalid JSON ! ' + e, 50000);
      return false;
    }
    return true;
  }
  cancel() {
    this.dialogRef.close();
  }
}
